import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";

import useTypedFlags from "hooks/useTypedFlags";

import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "../config/menuItemsPrimary";
import useMainNavigationStore from "../stores/useMainNavigationStore";
import useMainNavigationPrimaryItems from "./usePrimaryItems";

/**
 * Returns the default view without Account context checks,
 * this is safe to use in FlashContext and other components that load before Account data.
 */
export const useMainNavigationDefaultViewForNonAdmin = () => {
  const defaultViewItemId = useMainNavigationStore((state) => state.defaultViewItemId);
  const itemId = (defaultViewItemId ||
    MainNavigationPrimaryMenuItemKeys.Dashboard) as MainNavigationPrimaryMenuItemKeys;
  return MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[itemId];
};

const useMainNavigationDefaultView = () => {
  const { disableInfraAssistantDefaultView } = useTypedFlags();
  const { menuItemsMap } = useMainNavigationPrimaryItems();
  const { defaultViewItemId, setDefaultViewItemId } = useMainNavigationStore(
    useShallow((state) => ({
      defaultViewItemId: state.defaultViewItemId,
      setDefaultViewItemId: state.setDefaultViewItemId,
    }))
  );

  const defaultViewItem = useMemo(() => {
    if (defaultViewItemId && defaultViewItemId in menuItemsMap) {
      return menuItemsMap[defaultViewItemId];
    }

    if (
      !disableInfraAssistantDefaultView &&
      MainNavigationPrimaryMenuItemKeys.AiChat in menuItemsMap
    ) {
      return menuItemsMap[MainNavigationPrimaryMenuItemKeys.AiChat];
    }

    return menuItemsMap[MainNavigationPrimaryMenuItemKeys.Dashboard];
  }, [defaultViewItemId, menuItemsMap, disableInfraAssistantDefaultView]);

  return {
    defaultViewItem,
    setDefaultViewItemId,
  };
};

export default useMainNavigationDefaultView;
